<!--
  lovi
  银行卡验证 2020-09-17
-->
<template>
  <div class="verify">
    <Form :model="formModel">
      <FormItem>
        <Input
          prefix="ios-phone-portrait"
          type="text"
          v-model="userInfo.phone"
          readonly
        />
      </FormItem>
      <FormItem prop="code" class="item-code">
        <Input
          prefix="ios-lock-outline"
          type="text"
          v-model="code"
          class="codeInput"
          :placeholder="$t('common.enterVerificationCode')"
        />
        <span class="codeBtn" @click="sendMobile">{{ showMsg }}</span>
      </FormItem>
      <FormItem prop="password" class="item-password">
        <Input
          prefix="ios-lock-outline"
          type="password"
          v-model="password"
          password
          :placeholder="$t('common.enterPayPsd')"
        />
      </FormItem>
    </Form>
    <div class="button-wrap">
      <Button type="primary" long @click="confirm">
        {{ $t("common.confirm") }}
      </Button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      formModel: {},
      code: "", //验证码
      password: "",
      showMsg: this.$t("common.getItNow"),
      showTime: 60
    };
  },
  created() {},
  mounted() {},
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    sendMobile() {
      // 获取手机验证码
      let vm = this;
      let params = {};
      // 号码处理先删除空格转换成数字再补0
      params.phone = vm.userInfo.phone;
      params.type = 11;
      vm.$post("/app/captcha/sendMobile", params, {
        alert: true
      }).then(res => {
        console.log("sendMobile", res);
        if (res.code == 0) {
          vm.$Message.success(res.msg);
          vm.showMsg = vm.$t("common.remaining") + vm.showTime + "s";
          vm.setTimer();
        } else {
          vm.$Message.error(res.msg);
        }
      });
    },
    setTimer() {
      // 倒计时定时器
      let vm = this;
      clearTimeout(vm.timer);
      vm.timer = setTimeout(() => {
        if (vm.showTime == 0) {
          vm.showMsg = this.$t("common.getAgain");
          vm.showTime = 60;
          return false;
        }
        vm.showTime--;
        vm.showMsg = vm.$t("common.remaining") + vm.showTime + "s";
        vm.setTimer();
      }, 1000);
    },
    confirm() {
      //确定
      let vm = this;
      if (vm.code == "") {
        vm.$Message.error(vm.$t("verify.verificationCodeNull"));
        return false;
      }
      if (vm.password == "") {
        vm.$Message.error(vm.$t("common.enterPayPsd"));
        return false;
      }
      let params = {};
      params.code = vm.code;
      params.pay_password = vm.password;
      vm.$post("/app/bankcard/checkAddBankCardAuth", params, {
        loading: true
      }).then(res => {
        console.log("checkAddBankCardAuth", res);
        vm.$emit("update:verifyFlag", false);
        vm.$emit("update:bindCardFlag", true);
      });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.verify {
  padding: 50px 200px;
  /deep/.ivu-form {
    .ivu-form-item-label {
      line-height: 20px;
      font-size: 16px;
    }
    .ivu-form-item-content {
      .ivu-input {
        height: 40px;
      }
      .ivu-input-with-prefix {
        padding-left: 40px;
      }
      .ivu-input-suffix {
        cursor: pointer;
      }
      .ivu-input-suffix,
      .ivu-input-prefix {
        width: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        .ivu-icon {
          font-size: 22px;
          color: #2042ab;
        }
      }
    }
    .item-code {
      .ivu-input {
        padding-right: 90px;
      }
      .codeBtn {
        position: absolute;
        top: 0;
        right: 0;
        height: 40px;
        line-height: 40px;
        cursor: pointer;
        width: 90px;
        padding: 0 5px;
        text-align: center;
        color: #fe7800;
        font-size: 12px;
      }
    }
    .item-password {
      .ivu-input {
        padding: 0 40px;
      }
    }
  }
}
</style>
